export const radioGroupFormListPrimeiraReuniaoAprofundamento = [
    {
        id: 'P', 
        descricao: '1ª Reunião',
        ordem: 10,
    },
    {
        id: 'A', 
        descricao: 'Aprofundamento',
        ordem: 20,
    },
]



export const radioGroupFormListSimplificadoCompleto = [
    {
        id: 'P', 
        descricao: '1ª Reunião',//'Simulação Financeira',
        ordem: 10,
    },
    {
        id: 'A', 
        descricao: 'Cliente 360º',//'Estudo',
        ordem: 20,
    },
]